import * as Sentry from "@sentry/nuxt";

const config = useRuntimeConfig();
const dsn = config.public.sentryDsn || undefined;

Sentry.init({
  // A revoked DSN must not create a failed request on every page view. Set
  // NUXT_PUBLIC_SENTRY_DSN in the Deployment after provisioning a valid key.
  dsn,
  enabled: Boolean(dsn),
  release: config.public.sentryVersion || undefined,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,
  
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.1,
  
  // If you don't want to use Session Replay, just remove the line below:
  integrations: [Sentry.replayIntegration()],
  
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
